import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { BlockHeader } from 'components/blocks/BlockHeader';
import classNames from 'classnames';
import React, { useCallback, useMemo, useState } from 'react';
import { IRegionAllPathsInfo, IRegionShort } from 'api/region/types';
import { NextLink } from 'components/blocks/NextLink';
import { Routes } from 'routes';
import styles from './styles.module.scss';

export const ViewRegions = ({ regions, link }: { regions: IRegionAllPathsInfo, link: (r: IRegionShort) => string }) => {
  const [fullEUInfo, openFullEUInfo] = useState<boolean>(false);
  const { t } = useOTSTranslation('common');
  const sectionRegion: { [key: string]: Array<IRegionShort> } = {};
  (regions.groups ?? []).forEach((group, index) => {
    sectionRegion[index] = regions.regions.filter((region) => region.group === group.uuid);
  });
  const groupWithShowMoreLink = regions.groups.find((g) => g.showMoreTitle);
  const openEUSection = useCallback((status: boolean) => openFullEUInfo(status), []);
  const showRegions = (section: Array<IRegionShort>, i: number) => (
    section.map((region, index) => {
      if (region.group === groupWithShowMoreLink?.uuid) {
        if (index < 6 && !fullEUInfo) {
          return (
            <NextLink
              key={region.uuid}
              href={link(region)}
              className={styles.euRegion}
            >
              {region.title}
            </NextLink>
          );
        }

        if (index === 7 && !fullEUInfo) {
          return (
            <button
              key={region.uuid}
              type="button"
              className={styles.viewEU}
              onClick={() => openEUSection(true)}
            >
              {t('snowWeather.home.viewAllEuCountries')}
            </button>
          );
        }

        if (fullEUInfo) {
          return (
            <NextLink key={region.uuid} href={link(region)}>
              {region.title}
            </NextLink>
          );
        }
      } else {
        return (
          i === 1 && section.length > 9 ? (
            <div key={region.uuid}>
              <NextLink href={link(region)}>
                {region.title}
              </NextLink>
            </div>
          ) : (
            <NextLink key={region.uuid} href={link(region)}>
              {region.title}
            </NextLink>
          )
        );
      }

      return '';
    })
  );
  const regionsRendered = useMemo(() => showRegions, [sectionRegion]);
  const viewSectionRendered = useMemo(() => (
    Object.values(sectionRegion).map((section, i) => (
      <BoxWithShadow key={regions.groups[i].uuid}>
        <BlockHeader
          useH3
          title=""
          headChildren={
            regions.groups[i].slug
              ? <NextLink href={link(regions.groups[i])}>{regions.groups[i].title}</NextLink>
              : <div className={styles.blue}>{regions.groups[i].title}</div>
          }
        />
        <div className={classNames(styles.regions, i === 1 && section.length > 9 ? styles.sectionRows : '')}>
          {regionsRendered(section, i)}
        </div>
      </BoxWithShadow>
    ))
  ), [sectionRegion, regions]);

  return (
    <div className={styles.viewRegions}>
      <h2 className={styles.title}>
        {t('snowWeather.home.viewAllRegions')}
        {' / '}
        <NextLink
          href={Routes.nearbyResorts()}
        >
          {t('common.viewAllNearbyResorts')}
        </NextLink>
      </h2>
      {viewSectionRendered}
    </div>
  );
};
